import React from 'react';

const NewButton = ({ title, onClick }) => {
    return <button className="newButton" onClick={onClick}>{title}</button>
};

export default NewButton;
